import { Alert, Dialog, Stack, Typography } from '@all-manager/design-system-v2';
import type { DisplayedSubjectQuote } from '../../../../../types';
import useResetQuoteModal from './useResetQuoteModal';

type Props = {
  quote: DisplayedSubjectQuote;
  subjectId: string;
  onClose: () => void;
};

export default function ResetQuoteModal(props: Props) {
  const hook = useResetQuoteModal(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      maxWidth="sm"
      fullWidth
      title="Remettre le devis en attente"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Supprimer le document',
          color: 'error',
          onClick: hook.handleDeleteDocument,
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Conserver le document',
          onClick: hook.handleKeepDocument,
          disabled: hook.isPending,
        },
        tertiaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Typography variant="body1">
          Le bon pour accord <strong>{hook.documentName}</strong> est associé à ce devis.
        </Typography>
        <Typography variant="body2">
          Supprimez-le avec la validation, ou conservez-le et remettez seulement le devis en attente.
        </Typography>
      </Stack>
    </Dialog>
  );
}
